/**
 * This is a compiled JS file.
 * Changes here could be overwritten. 
 * Contact your Shopify developers if changes need to be made.
 */

class LayoutSwitch extends HTMLElement {
  constructor() {
    super();

    this.wrapperEl = this.querySelector('[data-layout-switch-wrapper]');

    if (!this.wrapperEl) {
      return;
    }

    this.defaultLayout = this.wrapperEl.dataset.layoutSwitchDefault || 'list';

    // Set from a cookie, or when a user makaes a selection
    this.selectedView = null;

    // Class to use in the classlist for the wrapper, so we can add the correct classname
    // ${this.wrapperClass}--${this.selectedView} -> `product-grid--list`
    this.wrapperClass = this.wrapperEl.dataset.layoutSwitchWrapper;

    // Add event handlers
    this.querySelectorAll('[data-layout-switch]').forEach((toggleButton) =>
      toggleButton.addEventListener('click', this.handleClick.bind(this))
    );

    this.init();
  }

  init() {
    // Check for a previously selected layout
    this.selectedView = getCookie('layout-switch') || this.defaultLayout;

    // Make selected view default in case of trade user returning logged out
    if (!window.spark && this.selectedView === "quick") {
      this.selectedView = this.defaultLayout;
      setCookie('layout-switch', this.selectedView, 365);
    }

    // Add initial class to layout
    this.wrapperEl.classList.add(`${this.wrapperClass}--${this.selectedView}`);

    // Disable the selected layout's button
    this.querySelectorAll(
      `[data-layout-switch="${this.selectedView}"]`
    ).forEach((toggleButton) => {
      toggleButton?.setAttribute('disabled', 'true');
    });
  }

  switchLayoutAttributes(selectedLayout) {
    // Filter out selected layout
    const inactiveLayouts = ['grid', 'list', 'quick'].filter(
      (l) => l !== selectedLayout
    );

    // Disable selected layout
    this.querySelector(
      `[data-layout-switch="${selectedLayout}"]`
    )?.setAttribute('disabled', 'true');

    // Set active layout class
    document
      .getElementById(this.wrapperClass)
      .classList.add(`${this.wrapperClass}--${selectedLayout}`);

    // Map over inactive layouts
    inactiveLayouts.map((i) => {
      this.querySelector(`[data-layout-switch="${i}"]`)?.removeAttribute(
        'disabled'
      );

      document
        .getElementById(this.wrapperClass)
        .classList.remove(`${this.wrapperClass}--${i}`);
    });
  }

  handleClick(e) {
    e.preventDefault();

    // Disable clicked button
    e.target?.setAttribute('disabled', 'true');

    // Update selected layout
    this.selectedView = e.target.dataset.layoutSwitch;

    this.switchLayoutAttributes(this.selectedView);

    // Update the cookie
    setCookie('layout-switch', this.selectedView, 365);
  }
}

if (!customElements.get('layout-switch')) {
  customElements.define('layout-switch', LayoutSwitch);
}
